/**
 * TopCashback UK Get Cashback & Vouchers — cashback helper
 *
 * Declares one WAR group matched to every URL with no use_dynamic_url: content/*.css
 * and content/*.svg, the toolbar icons (icon-32.png, icon-32-active.png) and the
 * icon_loop/*.png animation frames. The static PNG icons load via <img> with no CORS
 * grant, and content/styles.css corroborates from an independent path.
 *
 * Manifest verified against version 7.9.0.0.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'ekeeeebmbhkkjcaoicinbdjmklipppkj';

export const topcashback: ExtensionDefinition = {
  id: ID,
  name: 'TopCashback UK Get Cashback & Vouchers',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 200_000,
  notes:
    'Static icons and content styles on every origin with no dynamic URL. The PNG icons ' +
    'load without a CORS grant and are conclusive.',
  signals: [
    {
      id: 'war-icon-32-png',
      kind: 'web-accessible-resource',
      description:
        'Load icon-32.png via <img> — the toolbar icon exposed to every origin at a fixed ' +
        'URL; needs no CORS grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'icon-32.png'),
    },
    {
      id: 'war-icon-loop-0-png',
      kind: 'web-accessible-resource',
      description:
        'Load icon_loop/0.png via <img> — the first animation frame, corroborating the ' +
        'identification from a second image path.',
      weight: 0.5,
      run: () => probeImage(ID, 'icon_loop/0.png'),
    },
    {
      id: 'war-content-styles-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch content/styles.css — the injected content stylesheet, independent of the icons.',
      weight: 0.5,
      run: () => probeFetch(ID, 'content/styles.css'),
    },
  ],
};
